export const contentPadding = 'small' // 8px
